import { Injectable } from '@angular/core';

import { HttpStatusCode } from '@nano/common/http';
import { NavService } from '@nano/common/nav';
import { ErrorService } from '@nano/core/error';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class VerificationGuard {
  constructor(
    private navService: NavService,
    private errorService: ErrorService
  ) {}

  canActivate(): Observable<boolean> {
    return this.verificationInfoVisible();
  }

  canLoad(): Observable<boolean> {
    return this.verificationInfoVisible();
  }

  private verificationInfoVisible(): Observable<boolean> {
    return this.navService.verificationInfoVisible$.pipe(
      tap((verificationInfoVisible) => {
        if (!verificationInfoVisible) {
          this.errorService.navigateToErrorPage(HttpStatusCode.FORBIDDEN);
        }
      })
    );
  }
}
